const STEPS = [
  {
    step: "Step 01",
    title: "Choose Your Farm Portfolio",
    desc: "Browse by region or farm type and select a combination that fits your preferences. Every share is automatically diversified across multiple partner farms.",
    icon: "ri-checkbox-multiple-line",
  },
  {
    step: "Step 02",
    title: "Professional Farm Care",
    desc: "Certified veterinarians and herders follow standardized protocols. You can check cow health data and real-time farm monitoring anytime.",
    icon: "ri-heart-pulse-line",
  },
  {
    step: "Step 03",
    title: "Transparent Settlement · Returns Deposited",
    desc: "Monthly net farm income settled and automatically returned to your account by share. Quarterly audit reports published simultaneously.",
    icon: "ri-wallet-3-line",
  },
  {
    step: "Step 04",
    title: "Grow with the Community",
    desc: "Join annual farm visit days, shared reports, and member club events. Grow alongside dairy farming enthusiasts from around the world.",
    icon: "ri-team-line",
  },
];

export default function HowItWorks() {
  return (
    <section id="how" className="relative w-full bg-foreground-950 text-background-50 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20dark%20moody%20artistic%20close%20up%20of%20fresh%20green%20pasture%20grass%20blades%20covered%20in%20morning%20dew%20droplets%20with%20a%20soft%20warm%20golden%20light%20filtering%20through%2C%20cinematic%20macro%20nature%20photography%2C%20blurred%20abstract%20background%2C%20warm%20amber%20accent%20highlights%20against%20deep%20green%20and%20dark%20brown%20tones%2C%20highly%20detailed%20editorial%20mood&width=1920&height=1200&seq=vef-how-bg-01&orientation=landscape"
        alt="Morning Dew on Pasture"
        className="absolute inset-0 w-full h-full object-cover object-top opacity-25"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/95 via-foreground-950/90 to-foreground-950/95"></div>

      <div className="relative w-full px-6 md:px-10 lg:px-14 py-24 md:py-32">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/10 border border-background-50/20 text-background-50 text-xs font-semibold tracking-wide">
            <i className="ri-flow-chart"></i>
            How It Works
          </div>
          <h2
            className="mt-5 text-3xl md:text-5xl font-heading font-semibold tracking-tight leading-tight"
            style={{ fontFamily: "Fraunces, serif" }}
          >
            Four Steps to Join CCF, <span className="text-accent-400">Let Global Farms Work for You</span>
          </h2>
          <p className="mt-5 text-sm md:text-lg text-background-100/80 leading-relaxed">
            Simple, clear, and no hidden terms. You can view real data at every step.
          </p>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {STEPS.map((s, i) => (
            <div
              key={s.step}
              className="relative p-5 md:p-7 rounded-2xl bg-background-50/5 border border-background-50/10 hover:border-accent-400/60 transition-colors"
            >
              <div className="flex items-center justify-between">
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-500 text-background-50">
                  <i className={`${s.icon} text-2xl`}></i>
                </div>
                <span className="text-xs tracking-widest uppercase text-background-100/60">
                  {s.step}
                </span>
              </div>

              <h3
                className="mt-6 text-lg md:text-xl font-heading font-semibold"
                style={{ fontFamily: "Fraunces, serif" }}
              >
                {s.title}
              </h3>
              <p className="mt-3 text-xs md:text-sm text-background-100/75 leading-relaxed">
                {s.desc}
              </p>

              {i < STEPS.length - 1 && (
                <div className="hidden lg:block absolute -right-3 top-1/2 -translate-y-1/2 w-6 h-6 items-center justify-center rounded-full bg-accent-500 text-background-50 text-xs">
                  <i className="ri-arrow-right-line"></i>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}